import { c as _c } from "react/compiler-runtime";
import Summary from './Summary';
import { formatDateToString } from 'shared/dateFns';
import ProgressOverTime, { type ProgressOverTimeRecords } from './ProgressOvertime';
import React, { type ReactNode } from 'react';
import { type StandardReportResp } from 'shared/api/standardReports';
import Link from '@precis-digital/kurama/Link';
import Typography from '@precis-digital/kurama/Typography';
import { APP_ROUTES } from 'shared/routes';
import { UnStyledRetainDefaultQueryLink } from 'shared/components/Router';
import { useTranslation } from 'shared/translations';
import { type Metric } from 'src/home/reportTemplateParameters';
const ReportDataError = t0 => {
  const $ = _c(20);
  const {
    selectedMetrics,
    report,
    errorType
  } = t0;
  const {
    t
  } = useTranslation("home");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = formatDateToString({
      date: new Date(),
      targetFormat: "yyyy-MM-dd"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const date = t1;
  let errorBody = null;
  if (errorType != null) {
    let t2;
    if ($[1] !== errorType || $[2] !== report || $[3] !== t) {
      t2 = errorType === "status" && report != null ? <><Typography variant="h5">{t("chartReportStatusErrorTitle")}</Typography><Typography variant="body3">{t("chartReportStatusErrorPrompt1")}<UnStyledRetainDefaultQueryLink href={APP_ROUTES.reportingSolutions.editConfigPage({
            configId: report.configId.toString()
          })}><Link variant="body3" href="#">{t("chartReportStatusErrorPrompt2")}</Link></UnStyledRetainDefaultQueryLink>{" "}{t("chartReportStatusErrorPrompt3")}</Typography></> : <><Typography variant="h5">{t("chartReportUnknownErrorTitle")}</Typography><Typography variant="body3">{t("chartReportUnknownErrorPrompt")}</Typography></>;
      $[1] = errorType;
      $[2] = report;
      $[3] = t;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    errorBody = t2;
  }
  let progressOverTimeRecords;
  if ($[5] !== selectedMetrics) {
    progressOverTimeRecords = {};
    selectedMetrics.forEach(metric => {
      progressOverTimeRecords[metric] = [];
    });
    $[5] = selectedMetrics;
    $[6] = progressOverTimeRecords;
  } else {
    progressOverTimeRecords = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [date, date];
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== errorBody || $[9] !== progressOverTimeRecords) {
    t3 = <Summary startDate={date} endDate={date} previousTimePeriod={t2} summaryData={null} summaryDataForPreviousTimePeriod={null} progressOverTimeRecords={progressOverTimeRecords} errorBody={errorBody} />;
    $[8] = errorBody;
    $[9] = progressOverTimeRecords;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    t5 = [];
    t6 = [];
    t7 = [date, date];
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[15] !== errorBody) {
    t8 = <ProgressOverTime isBudgetMode={false} metrics={t4} reports={t5} reportsForPreviousTimePeriod={t6} timePeriod={t7} errorBody={errorBody} />;
    $[15] = errorBody;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t8) {
    t9 = <>{t3}{t8}</>;
    $[17] = t3;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default ReportDataError;